import React from "react";
import {Container, Link, Paper, Stack, Typography} from "@mui/material";
import {
    Timeline,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineOppositeContent,
    TimelineSeparator
} from "@mui/lab";


export function TimelineElem({content}) {
    return (
        <TimelineItem>
            {content.img && <TimelineOppositeContent color="text.secondary">
                <img height={300} alt="capture" src={content.img}/>
            </TimelineOppositeContent>}
            <TimelineSeparator>
                <TimelineDot/>
                <TimelineConnector/>
            </TimelineSeparator>
            <TimelineContent>
                <Typography variant="h6" fontWeight="bold" color="textSecondary">
                    {content.title}
                </Typography>
                <Typography textAlign="justify">
                    <Stack spacing={1}>
                        {content.description}
                    </Stack>
                </Typography>
            </TimelineContent>
        </TimelineItem>
    );
}


const content = [
    {
        title: "PIVAN EXOPOPP",
        img: "/assets/history/exopopp.png",
        description: <>
            <Typography>
                Ce projet vise à élaborer une vaste base de données à partir de 300 000 actes de mariages de Paris et sa
                banlieue entre 1880 et 1940. Grâce à la collaboration d’informaticiens et de chercheurs en sciences
                sociales, ce projet permettra des avancées considérables.
                Les derniers progrès en reconnaissance d’écritures manuscrites et en traitement automatique du langage
                naturel, grâce au Deep Learning, permettent d’envisager des avancées significatives dans la
                compréhension et
                l’extraction optique d’entités nommées manuscrites. C’est l’ambition du projet EXO-POPP de développer de
                nouveaux algorithmes et de les appliquer à l’analyse des actes de mariages qui offrent un cas d’étude
                exemplaire pour l’utilisation de ces nouvelles techniques.
                EXO-POPP va considérablement améliorer la compréhension des transformations familiales sous la IIIᵉ
                République. Au-delà, l’automatisation de la transcription d’archives laisse entrevoir d’immenses
                possibilités pour la recherche historique quantitative.
            </Typography>
            <Link color="inherit" underline="none" href="https://exopopp.hypotheses.org/" target="_blank"
                  rel="noopener">
                source: hypotheses.org
            </Link>
        </>
    },
    {
        title: "PIVAN 2 API et Front",
        img: "/assets/history/swagg.png",
        description: <Typography>
            L'objectif initial du projet PIVAN 2 était de fusionner les différentes versions développées au fil des
            années. Comme cela s'est avéré impossible, le projet a été relancé sur une base moderne. PIVAN dispose
            désormais d'une API REST et d'un front-end moderne.
        </Typography>
    },
    {
        title: "PIVAN EURHISFIRM",
        img: "/assets/history/eurhisfirm.png",
        description: <Link color="inherit" underline="none" href="https://eurhisfirm.eu/index.php/the-project-2/"
                           target="_blank"
                           rel="noopener">
            eurhisfirm.eu
        </Link>
    },
    {
        title: "PIVAN POPP",
        img: "/assets/history/popp.png",
        description: <Typography>Projet d'Océrisation de la Population Parisienne. Permet de visualiser les archives des
            cahiers de recensement de la ville de Paris.</Typography>
    },
    {
        title: "PIVAN HBDEX",
        img: "/assets/history/hbdex.png",
        description: <Typography>Permet de visualiser les cahiers des côtes des valeurs boursières.</Typography>
    },
    {
        title: "PIVAN",
        img: "/assets/history/pivan.png",
        description: <Typography>Permet de visualiser des manuscrits italiens du XVIIe siècle.</Typography>
    },
    {
        title: "PIVAJ",
        img: "/assets/history/pivaj.png",
        description: <>
            <Typography>
                Dans le cadre de l'application sur les archives patrimoniales, PlaIR a donné naissance au projet
                PIVAJ. Nos outils ont pour but d'extraire l'information contenue dans les archives de journaux,
                ainsi que sa structure, et de proposer leur consultation en ligne à l'aide d'une plateforme
                alliant visualisation des pages, consultation des articles transcrits automatiquement, recherche
                plein-texte et correction collaborative.
            </Typography>
            <Typography>
                Grâce à une collaboration avec les Archives Départementales de Seine-Maritime, nous avons
                construit un premier prototype mettant en ligne 80 années du Journal de Rouen, un des plus
                anciens titres de presse locale de France. Le succès de PIVAJ auprès des utilisateurs, en
                comparaison des solutions existantes, nous a convaincu de chercher à pérenniser ce travail en
                améliorant nos outils de traitement et en modernisant la plateforme de consultation.
            </Typography>
            <Typography>
                Le Journal de Rouen est un des plus anciens journaux régionaux de France. Il a commencé à paraître en
                juin 1762, sous le titre d'Annonces, affiches et avis divers de la Haute et Basse Normandie, est devenu
                le Journal de Rouen et du département de la Seine-Inférieure en 1791, puis le Journal de Rouen au XIXe
                siècle jusqu'en 1944. Normandie, et Paris-Normandie lui ont succédé. La collection du Journal de Rouen
                constitue l'une des principales sources d'informations pour la région dans des domaines très variés :
                vie économique et sociale, politique et culturelle.
            </Typography>
            <Typography>
                L'opération de numérisation-océrisation de ce périodique, entreprise par les Archives départementales de
                Seine-Maritime en 2008, a été menée à bien avec l'aide financière du Ministère de la Culture (Mission de
                la Recherche et de la Technologie) et en collaboration avec la Bibliothèque Municipale de Rouen, qui a
                prêté une partie de ses collections. La Société Normande de Presse d'Edition et d'Impression
                (Paris-Normandie) a également apporté son soutien à l'opération en prêtant sa collection pour les années
                1945-1947.
            </Typography>
        </>
    },
    {
        title: "PLAIR",
        img: "/assets/history/plair.png",
        description: <>
            <Typography>
                Le projet PlaIR, réalisé durant la période 2010-2012, se donnait pour objectif de mutualiser, d'une
                part, un ensemble de ressources documentaires numériques, et, d'autre part, les composant logiciels
                permettant d'analyser automatiquement ces ressources. Ceci était fait dans le but de constituer une
                plateforme d'indexation et de recherche d'information multi-domaines et multi-usages. Quatre domaines
                d'applications avaient été retenus pour constituer autant de démonstrateurs de cette plateforme : la
                santé, l'ingénierie, le droit, ainsi que les archives patrimoniales numérisées.
            </Typography>
            <Typography>
                Le projet s'articulait autour de trois objectifs complémentaires :
                <ul>
                    <li>Des travaux scientifiques avancés de modélisation des connaissances et des données, réalisés
                        notamment par des (post-)doctorants encadrés par les équipes de recherche impliquées dans le
                        projet.
                    </li>
                    <li>
                        Des développements logiciels mettant en œuvre ces travaux pour traiter les ressources
                        documentaires.
                    </li>
                    <li>
                        Des démonstrateurs concrétisant les applications prévues et intégrant des moyens de
                        visualisation et d'interrogation pour les corpus traités et indexés.
                    </li>
                </ul>
            </Typography>
        </>
    }
]

export default function History() {
    return (
        <Container sx={{p: 2, mb: 2, mt: 2}}>
            <Paper elevation={0}>
                <Timeline position="alternate">
                    {content.map((content) => (<TimelineElem content={content}/>))}
                </Timeline>
            </Paper>
        </Container>
    );
}